module.exports = __webpack_public_path__ + "static/media/c-nuts-free.7a062ba5.jpg";